export const pVuVColor = ['#1976D2', '#43B74B'];
export const searchColor = [
    '#1976D2',
    '#27B4D1',
    '#43B74B',
    '#A2C716',
    '#CDCE12',
    '#FABB27',
    '#FD865A',
    '#FF6C73',
    '#E96A94',
    '#A863F7',
    '#D174D6'
];
export const productColor = [
    '#1976D2',
    '#27B4D1',
    '#43B74B',
    '#FABB27',
    '#F8D50E',
    '#CDCE12',
    '#FABB27',
    '#FD865A',
    '#FF6C73',
    '#E96A94',
    '#A863F7',
    '#D174D6'
];
export const lineBarColor = [
    '#1976D2',
    '#43B74B',
    '#FABB27',
    '#A863F7',
    '#E96A94'
];
export const lineColor = [
    '#1976D2',
    '#43B74B',
    '#FABB27',
    '#FD865A'
];
export function getBarOptions() {
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
            textStyle: {
                color: '#020A1A',
                fontSize: 12,
                fontWeight: 400,
            },
        },
        legend: {
            type: 'scroll',
            orient: 'horizontal',
            bottom: 0,
            left: 'center',
            itemGap: 30,
            textStyle: {
                color: '#020A1A',
                fontSize: 12,
            },
        },
        color: pVuVColor,
        grid: {
            left: '3%',
            right: '4%',
            bottom: '8%',
            top: '8%',
            containLabel: true,
        },
        dataset: {
            source: [],
        },
        xAxis: {
            type: 'category',
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                margin: 12,
                color: '#061632',
                fontSize: 10,
                rotate: 45,
            },
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                color: '#061632',
                fontSize: 10,
            },
        },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [],
    };
}
export function getLineBarOptions() {
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
            textStyle: {
                color: '#020A1A',
                fontSize: 12,
                fontWeight: 400,
            },
        },
        legend: {
            type: 'scroll',
            orient: 'horizontal',
            bottom: 0,
            left: 'center',
            itemGap: 30,
            textStyle: {
                color: '#020A1A',
                fontSize: 14,
            },
        },
        color: lineBarColor,
        dataset: {
            source: [],
        },
        xAxis: {
            type: 'category',
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                margin: 12,
                color: '#061632',
                fontSize: 10,
                rotate: 45,
            },
        },
        yAxis: [
            {
                type: 'value',
                position: 'left',
                axisLabel: {
                    formatter: '{value}',
                    color: '#061632',
                    fontSize: 10,
                },
            },
            {
                type: 'value',
                position: 'right',
                axisLabel: {
                    formatter: '{value} %',
                    color: '#061632',
                    fontSize: 10,
                },
                min: 0,
                max: 100,
            }
        ],
        series: [],
    };
}
export function getLineOption() {
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
            textStyle: {
                color: '#020A1A',
                fontSize: 12,
                fontWeight: 400,
            },
        },
        color: lineColor,
        legend: {
            type: 'scroll',
            orient: 'horizontal',
            bottom: 0,
            left: 'center',
            itemGap: 30,
            textStyle: {
                color: '#020A1A',
                fontSize: 12,
            },
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '8%',
            top: '8%',
            containLabel: true,
        },
        xAxis: {
            type: 'category',
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                margin: 12,
                color: '#061632',
                fontSize: 10,
                rotate: 45,
            },
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                color: '#061632',
                fontSize: 10,
            },
        },
        series: [],
    };
}
// 数据库 Email chart配置
export const analyticsEmailSeriesOption = [
    {
        key: 'recipients',
        type: 'bar',
    },
    {
        key: 'read',
        type: 'bar',
    },
    {
        key: 'clicked',
        type: 'bar',
    },
    {
        key: 'read_ratio',
        type: 'line',
    },
    {
        key: 'clicked_ratio',
        type: 'line',
    }
];
